import tokens from '@/PrimeVue/customDesignTokens';

export const selectUploadsDt = {
  colorScheme: {
    light: {
      background: tokens.button.background.colors.default,
      borderColor: tokens.button.border.colors.default,
      hoverBorderColor: tokens.button.border.colors.hover,
      borderRadius: tokens.button.border.radius,
      shadow: tokens.primitive.shadows.none,
      transitionDuration: '0s',
      paddingX: '0',
      paddingY: '4px'
    }
  }
};

export const selectUploadsPt = {
  option: 'select-uploads-option'
};